import React, { useState } from "react";
import { useEffect } from "react";
import { useParams } from "react-router";
import { toast } from "react-toastify";
//--------------------api handler------------------
import AllianceManagerServices from "../../../services/API/AllianceManager";

import { saveAs } from "file-saver";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from "moment";
import fileDownload from "js-file-download";
import Loader from "../../Loader";
import FullScreenLoader from "../../FullScreenLoader";
import { getDocName } from "../../../utils/utils";
import useAuth from "../../../hooks/useAuth";
import { ROLES } from "../../../constant/roles";
import CustomModal from "../../common/CustomModal";
import { set } from "date-fns";
import { el } from "date-fns/locale";
import { all } from "axios";

const DocumentList = ({ documentStatus, setDocumentStatus, srnStatues, licenseRequestDetails, eligible, srn_name, allDocuments, setAllDocuments, setAllOtherDocuments, allOtherDocuments, updateStatus, details }) => { //27-08-2024 - p1:status matrix update - Subha
  const { license_id } = useParams();
  const [rejectModal, setRejectModal] = useState(false);
  const [rejectRemarks, setRejectRemarks] = useState("");

  const [documentStatuss, setDocumentStatuss] = useState([]);
  const [otherDocumentStatuss, setOtherDocumentStatuss] = useState([]);
  const [documentIdsToDownload, setDocumentIdsToDownload] = useState([]);
  const [otherDocumentIdsToDownload, setOtherDocumentIdsToDownload] = useState([]);
  const [allCheckStatus, setAllCheckStatus] = useState(false);
  const [otherAllCheckStatus, setOtherAllCheckStatus] = useState(false);
  const [detailsList, setDetailsList] = useState([]);
  const [actionBtn,setActionBtn] = useState(false)
  const [loader, setLoader] = useState("");
  const [editModal, setEditModal] = useState(false);
  const [editData, setEditData] = useState("");
  const [editID, setEditId] = useState("");
  const [otherReject, setOtherReject] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState({ show: false, id: null, type: null });
  const auth = useAuth();

  useEffect(() => {
    getAllDocuments();
  }, []);

  useEffect(() => {
    if (details?.is_final_submit !== 1) {
      getAllDocuments();
    }
  }, [details?.is_final_submit]);

  const DOC_STATUS = allDocuments?.filter((doc) => doc?.doc_status === 2);
  const OTHER_DOC_STATUS = allOtherDocuments?.filter((doc) => doc?.status === "2");
  const getAllDocuments = async () => {
    try {
      const response = await AllianceManagerServices.getAllDocuments(
        license_id
      );
      if (response?.status == "Success") {
        setAllDocuments(response?.data?.user_documents);
        setAllOtherDocuments(response?.data?.user_other_documents);
        const ids = response?.data?.user_documents?.filter((item) => item?.is_doc_upload_completed === "1")?.map((item) =>
          item.id.toString()
        );
        const other_doc_ids = response?.data?.user_other_documents?.filter((item) => item?.is_doc_upload_completed === "1").map((item) =>
          item.id.toString()
        );
        setDocumentIdsToDownload(ids);
        setOtherDocumentIdsToDownload(other_doc_ids);
        setDetailsList(response?.data?.user_license_field_details);
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoader("");
    }
  };

  const handleAccept = async (is_other) => {
 
    const payload = {
      document_id: documentStatuss,
      other_document_id: otherDocumentStatuss,
      user_accept: 1,
      document_name:getDocName(documentStatuss,allDocuments),
      other_document_name:getDocName(otherDocumentStatuss,allOtherDocuments),
      srn_id:license_id,
      is_other : is_other
    };

    try {
      setActionBtn(true)
      if (payload.other_document_id.length <= 0 && payload.document_id.length <= 0) {
        toast.error("Please accept the documents to process the request.");
      } else {
        const response = await AllianceManagerServices.srnDocumentListUpdate(
          payload
        );
        if (response?.status == "success") {
          toast.success("Document status updated");
          setDocumentStatuss([]);
          setOtherDocumentStatuss([]);
          getAllDocuments();
          licenseRequestDetails()
        } else {
          toast.error(response.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
    }finally{
      setActionBtn(false);
      setOtherReject(false);
    }
  };

  const handleReject = async () => {

    const payload = {
      document_id: documentStatuss,
      other_document_id: otherDocumentStatuss,
      user_reject: 0,
      reject_remarks: rejectRemarks,
      document_name:getDocName(documentStatuss,allDocuments),
      other_document_name:getDocName(otherDocumentStatuss,allOtherDocuments),
      srn_id:license_id,
      is_other : otherReject
    };
    if (!rejectRemarks) {
      toast.error("Please enter remarks for rejection");
      return;
    }
    setRejectModal(false);
    try {
      setLoader("document reject");
      if (payload.other_document_id.length <= 0 && payload.document_id.length <= 0) {
        setRejectRemarks("");
        toast.error("Please accept the documents to process the request");
      } else {
        const response = await AllianceManagerServices.srnDocumentListUpdate(
          payload
        );

        if (response?.status == "success") {
          setRejectRemarks("");
          toast.success("Document Status Updated");
          setDocumentStatuss([]);
          setOtherDocumentStatuss([]);
          getAllDocuments();
          licenseRequestDetails()
        } else {
          toast.error(response.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoader("");
      setOtherReject(false);
    }
  };
  const markAll = (checkStatus) => {
    if (checkStatus) {
      setDocumentStatuss([]);
      setAllCheckStatus(false);
    } else {
      const ids = allDocuments
        ?.filter((item) => item?.doc_status === 2)
        .map((item) => item.id.toString());
      setDocumentStatuss(ids);
      setAllCheckStatus(true);
    }
  };
  const markOtherAll = (otherAllCheckStatus) => {
    if (otherAllCheckStatus) {
      setOtherDocumentStatuss([]);
      setOtherAllCheckStatus(false);
    } else {
      const ids = allOtherDocuments
        ?.filter((item) => item?.status === "2")
        .map((item) => item.id.toString());
        setOtherDocumentStatuss(ids);
        setOtherAllCheckStatus(true);
    }
  };

  const handleDownloadZip = async () => {
    const response = await AllianceManagerServices.downloadAllDocuments(
      documentIdsToDownload
    );
    if (response) {
      const url = window.URL.createObjectURL(
        new Blob([response], { type: "application/zip" })
      );
      const link = document.createElement("a");
      link.href = url;
      var name = (srn_name) ? srn_name +"_documents.zip" : "documents.zip"; //25-Feb-2025 -  Downloaded Zip File Name (SRN name)- karthikeyan
      link.setAttribute("download", name); //25-Feb-2025 -  Downloaded Zip File Name (SRN name)- karthikeyan
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      toast.success("All Documents downloaded Successfully");
    }
  };
  const OtherDocDownloadZip = async () => {
    const response = await AllianceManagerServices.downloadAllDocuments(
      otherDocumentIdsToDownload,true
    );
    if (response) {
      const url = window.URL.createObjectURL(
        new Blob([response], { type: "application/zip" })
      );
      const link = document.createElement("a");
      link.href = url;
      var name = (srn_name) ? srn_name +"_documents.zip" : "documents.zip"; //25-Feb-2025 -  Downloaded Zip File Name (SRN name)- karthikeyan
      link.setAttribute("download", name); //25-Feb-2025 -  Downloaded Zip File Name (SRN name)- karthikeyan
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      toast.success("All Documents downloaded Successfully");
    }
  };
  const downloadSingleFile = async (docName, docId, ext, is_other=0) => {
    try {
      let type = "";
      allDocuments?.forEach((item) => {
        if (item.id === docId) {
          type = item.type.split("/")[1];
        }
      });

      const response = await AllianceManagerServices.downloadSingleDocument(
        docId + "?is_other=" + is_other
      );
      if (response) {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${docName}.${
            ext === "xlsx"
              ? "xlsx"
              : ext === "xls"
              ? "xls"
              : ext === "bmp"
              ? "bmp"
              : ext === "pdf" 
              ? "pdf" 
              : ext === "jpeg"
              ? "jpeg" 
              : ext
          }`
        );
        link.click();
        toast.success("Document Downloaded Successfully");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const EditOtherDocument = async () => {
    setEditModal(false);
    const payload = {
      is_edit : true,
      id : editID,
      document_name : editData
    }
    try {
      setLoader("document update");
      const response = await AllianceManagerServices.UpdateOtherDocument(
        payload
      );
      if (response?.status == "success") {
        setEditId("");
        setEditData("");
        toast.success('Document Updated Successfully');
        getAllDocuments();
      } else {
        toast.error(response.message);
      }
    } catch(e) {
      toast.error(e.message);
    }
  }
  const UpdateOtherDocument = async (id) => {
    const payload = {
      is_delete : id ? true : false,
      id : id,
      user_service_id : license_id
    }
    try {
      setLoader("document update");
      const response = await AllianceManagerServices.UpdateOtherDocument(
        payload
      );
      if (response?.status == "success") {
        getAllDocuments();
        toast.success(payload?.is_delete?'Document Deleted Successfully':'Document Approved');
      } else {
        toast.error(response?.message);
      }
    } catch(e) {
      toast.error(e.message);
    }
  }
  const removeSrnDocument = async (id) => {
    const payload = {
      id : id 
    }
    try {
      setLoader("document update");
      const response = await AllianceManagerServices.removeSrnDocument(
        payload
      );
      if (response?.status == "success") {
        getAllDocuments();
        toast.success('Document Deleted Successfully');
      } else {
        toast.error(response?.message);
      }
    } catch(e) {
      toast.error(e.message);
    } finally {
      setLoader("");
    }
  }

  return (
    <>
      {loader === "document reject" || loader === "document update" ? (
        <FullScreenLoader
          show={loader === "document reject" || loader === "document update"}
          title="updating document status"
        />
      ) : (
        ""
      )}
      <div className="card card-sm card-shadow mb-3">
        <Modal
          show={rejectModal}
          onHide={() => setRejectModal(false)}
          animation={false}
          centered
          //  className="filter-modalbox"
        >
          <Modal.Header closeButton>
            <Modal.Title>Remarks</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <textarea
              style={{ width: "100%" }}
              rows="4"
              cols="50"
              value={rejectRemarks}
              onChange={(e) => setRejectRemarks(e.target.value)}
            ></textarea>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="success"
              className="px-3 py-2"
              onClick={handleReject}
              disabled={loader === "document reject"}
            >
              {/* {loader === "reject" ? (
                <div className="d-flex align-items-center gap-2">
                  <Loader /> loading...
                </div>
              ) : ( */}
              Submit
              {/* )} */}
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={editModal}
          onHide={() => setEditModal(false)}
          animation={false}
          centered
          //  className="filter-modalbox"
        >
          <Modal.Header closeButton>
            <Modal.Title>Other Document Name</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <input
              style={{ width: "100%" }}
              value={editData}
              onChange={(e) => setEditData(e.target.value)}
            ></input>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="success"
              className="px-3 py-2"
              onClick={EditOtherDocument}
              // disabled={loader === "document reject"}
            >
              {/* {loader === "reject" ? (
                <div className="d-flex align-items-center gap-2">
                  <Loader /> loading...
                </div>
              ) : ( */}
              Submit
              {/* )} */}
            </Button>
          </Modal.Footer>
        </Modal>
        <div className="card-body">
          <h3
            style={{ marginBottom: "0 !important" }}
            className="heading_light"
          >
            <i
              className="fa fa-copy fa-fw"
              aria-hidden="true"
              style={{ color: "#64308e" }}
              title="Documents List"
            ></i>
            Documents Lists
            {allDocuments?.length > 0 && (() => {
              const total = allDocuments.length;
              const uploaded = allDocuments.filter(d => d.doc_status === 1 || d.doc_status === 2).length;
              return (
                <span className="sdl-pill-badge">
                  <span className="sdl-pill-text">{uploaded} / {total} Documents Uploaded</span>
                </span>
              );
            })()}

            {allDocuments?.length > 0  && details?.is_final_submit === 1 &&
              <a
                className="btn btn-xs button_new pull-right mt-2"
                onClick={handleDownloadZip}
                onKeyDown={handleDownloadZip}
              >
                <i
                  className="fa fa-download fa-fw requests-icons"
                  style={{ color: "#64308e" }}
                  title="Download"
                ></i>
                Download All Documents
              </a>
            }

          </h3>

          {/* {(allDocuments?.length > 0 
          &&
        allDocuments.find((item) => item.doc_status === 2) !== undefined ) */}

          {allDocuments?.length > 0 && allDocuments.is_submit !== 0 &&
            allDocuments.find((item) => item.doc_status === 2 && item.is_submit === 1) !== undefined &&
          srnStatues?.status !== "Closed" &&
          srnStatues?.status !== "Completed" && srnStatues?.status !== "Cancelled" && eligible &&
          details?.is_final_submit === 1 ? ( //27-08-2024 - p1:status matrix update - Subha
            <>
              <button
                className="button_new m-2"
                onClick={() => {
                  handleAccept(false)
                }}
                style={{ cursor: "pointer" }}
                disabled={actionBtn}
              >
                <i class="fa-solid fa-check" style={{ color: "green" }}></i>
                &nbsp;Accept
              </button>
              <button
                className="button_new"
                onClick={() => {
                  if (documentStatuss?.length) {
                    setRejectModal(true);
                  } else {
                    toast.error(
                      "Minimum one document required to process this request."
                    );
                  }
                }}
                style={{ cursor: "pointer" }}
              >
                <i class="fa-solid fa-xmark" style={{ color: "red" }}></i>
                &nbsp;Reject
              </button>
            </>
          ) : (
            ""
          )}

          <div className="table-responsive">
            <table className="table table-bordered eg-1 mt-3">
              <thead>
                <tr style={{ fontSize: "12px", fontWeight: "700" }}>
                  {auth?.roleId !== ROLES.customerSupport && <th width="8%">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="coi"
                      checked={allCheckStatus}
                      hidden={
                        !DOC_STATUS?.length ||
                        srnStatues?.status == "Closed" ||
                        srnStatues?.status == "Completed"
                          ? true
                          : false
                      }
                      onChange={() => {
                        markAll(allCheckStatus);
                      }}
                      id="defaultCheck1"
                      style={{ marginLeft: "10px" }}
                    />
                  </th>}
                  <th style={{ textAlign: "center", width: "22%" }}>
                    Document Name
                  </th>
                  <th style={{ textAlign: "center" }}>Document</th>
                  <th style={{ textAlign: "center", width: "20%" }}>
                    Uploaded on
                  </th>
                  <th style={{ textAlign: "center", width: "15%" }}>Status</th>
                  {eligible && allDocuments?.some(item => !item?.is_submit) && <th style={{ textAlign: "center", width: "15%" }}>Action</th>}
                </tr>
              </thead>
              <tbody>
                {allDocuments?.map((item, i) => {
                    // let s = false
                    // let filltered = documentStatuss.filter((doc)=>doc.id===item.id.toString())
                    // if(filltered.length > 0 ){
                    //        s =  filltered.status
                    // }
                    return (
                      <tr key={i} style={{ fontSize: "12px" }}>
                        {auth?.roleId !== ROLES.customerSupport && <td width="5%">
                          {item?.is_doc_upload_completed == 1 && item?.is_submit === 1 && <input
                            style={{ marginLeft: "14px" }}
                            class="form-check-input"
                            type="checkbox"
                            value="coi"
                            checked={
                              documentStatuss.includes(item.id.toString())
                                ? true
                                : false
                            }
                            onChange={() => {
                              let filteredItem1 = documentStatuss.filter(
                                (document) => document === item.id.toString()
                              );
                              let filteredItem2 = documentStatuss.filter(
                                (document) => document !== item.id.toString()
                              );
                              if (!filteredItem1.length > 0) {
                                setDocumentStatuss([
                                  ...documentStatuss,
                                  item.id.toString(),
                                ]);
                              } else {
                                setDocumentStatuss(filteredItem2);
                              }
                            }}
                            //  onChange={() =>{

                            //    setDocumentStatus({
                            //      ...documentStatus,
                            //      ["certificateOfIncorporate"]: !documentStatus.certificateOfIncorporate,
                            //     })
                            //   }
                            //  }
                            id="defaultCheck1"
                            hidden={
                              item?.doc_status !== 2 ||
                              srnStatues?.status === "Closed" ||
                              srnStatues?.status === "Completed"
                                ? true
                                : false
                            }
                          />}
                        </td>}
                        <td>
                          <strong>{item?.document?.name}</strong>
                        </td>
                        <td>
                        {(item?.is_submit === 1 || item?.doc_status === 0) && 
                          <OverlayTrigger
                            overlay={
                              <Tooltip id="tooltip-disabled">Download</Tooltip>
                            }
                          >
                            <i
                              className="fa-solid fa-file-arrow-down"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                downloadSingleFile(
                                  item.name,
                                  item.id,
                                  item.extension
                                )
                              }
                              onKeyDown={() =>
                                downloadSingleFile(
                                  item.name,
                                  item.id,
                                  item.extension
                                )
                              }
                            ></i>
                          </OverlayTrigger>
                        }
                          &nbsp; {item?.is_submit === 1 || item?.doc_status === 0 ? item?.name+"."+item?.extension : ""}
                        </td>
                        <td>
                          {(item?.is_submit == "1" || item?.doc_status === 0) && moment(item?.created_at).format("DD-MM-YY hh:mm A")}
                        </td>
                        <td>
                          {(() => {
                            const statusMap = {
                              0: { color: "red", text: "Rejected" },
                              1: { color: "green", text: "Accepted" },
                              2: { color: "orange", text: "Pending" },
                              3: { color: "orange", text: "Awaiting user upload" },
                            };

                            const { color, text } = statusMap[item?.is_submit || item?.doc_status == 0 ? item?.doc_status : 3]; // default to 'Awaiting user upload'

                            return (
                              <span>
                                <i
                                  className="fa fa-circle fa-fw"
                                  aria-hidden="true"
                                  style={{ color }}
                                ></i>{" "}
                                {text}
                              </span>
                            );
                          })()}
                        </td>
                        {eligible && allDocuments?.some(doc => !doc?.is_submit) && (
                          <td style={{ textAlign: "center" }}>
                            {!item?.is_submit && (
                              <i
                                className="fa fa-trash fa-fw fa-lg"
                                style={{ cursor: "pointer", color: "red" }}
                                onClick={() => setDeleteConfirm({ show: true, id: item?.id, type: "srn" })}
                              ></i>
                            )}
                          </td>
                        )}
                        {/* {eligible && <td>
                          {item?.is_additional == 1 && <button
                            type="button"
                            className="btn btn-danger btn-sm fs-5 p-2 pt-0 pb-0 m-8 ml-0 mt-0 mb-0"  
                            onClick={() => {
                              UpdateOtherDocument(item?.id)
                            }}
                          >Delete</button>}
                        </td>} */}
                      </tr>
                    );
                  })}
              </tbody>
              {/* {details?.is_final_submit === 0 && <tr className="mt-1">
                <td colSpan={5}  
                  style={{
                    textAlign: "center",
                    padding: "4px 0",
                    lineHeight: "2"
                  }}>
                  No data found
                </td>
              </tr>} */}
            </table>
          </div>
        </div>
        {allOtherDocuments?.length > 0 &&  <div className="card-body">
          <h3
            style={{ marginBottom: "0 !important" }}
            className="heading_light"
          >
            <i
              className="fa fa-copy fa-fw"
              aria-hidden="true"
              style={{ color: "#64308e" }}
              title="Documents List"
            ></i>
            Other Documents List
            {allOtherDocuments?.length > 0 && (() => {
              const total = allOtherDocuments.length;
              const uploaded = allOtherDocuments.filter(d => d.status === "1" || d.status === "2").length;
              return (
                <span className="sdl-pill-badge">
                  <span className="sdl-pill-text">{uploaded} / {total} Documents Uploaded</span>
                </span>
              );
            })()}

            {/* allOtherDocuments.filter((item) => item.is_doc_upload_completed === "1").length > 0  - Varadarajan June 10th 2026*/} 

            {allOtherDocuments?.length > 0 && details?.is_final_submit === 1 && <a
              className="btn btn-xs button_new pull-right mt-2"
              onClick={OtherDocDownloadZip}
              onKeyDown={OtherDocDownloadZip}
            >
              <i
                className="fa fa-download fa-fw requests-icons"
                style={{ color: "#64308e" }}
                title="Download"
              ></i>
              Download All Documents
            </a>}
          </h3>
          {allOtherDocuments?.length > 0 && allOtherDocuments.is_submit !== 0 &&
            allOtherDocuments.find((item) => item.status === "2" && item.is_submit === 1) !== undefined &&
            srnStatues?.status !== "Closed" &&
            srnStatues?.status !== "Completed" && srnStatues?.status !== "Cancelled" && eligible &&
            details?.is_final_submit === 1 ?  ( 
              <>
                <button
                  className="button_new m-2"
                  onClick={() => {
                    handleAccept(true)
                  }}
                  style={{ cursor: "pointer" }}
                  disabled={actionBtn}
                >
                  <i class="fa-solid fa-check" style={{ color: "green" }}></i>
                  &nbsp;Accept
                </button>
                <button
                  className="button_new"
                  onClick={() => {
                    if (otherDocumentStatuss?.length) {
                      setRejectModal(true);
                      setOtherReject(true);
                    } else {
                      toast.error(
                        "Minimum one document required to process this request."
                      );
                    }
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <i class="fa-solid fa-xmark" style={{ color: "red" }}></i>
                  &nbsp;Reject
                </button>
              </>
            ) : (
              auth?.roleId == ROLES.allianceManager &&
                allOtherDocuments.find((item) => item.status === "3") !== undefined
                  && srnStatues?.status !== "Cancelled"
                  && 
                  <button
                    className="button_new m-2"
                    onClick={() => {
                      UpdateOtherDocument()
                    }}
                    style={{ cursor: "pointer" }}
                    // disabled={actionBtn}
                  >
                    <i class="fa-solid fa-check" style={{ color: "green" }}></i>
                    &nbsp;Approve
                  </button>
          )}

          <div className="table-responsive">
            <table className="table table-bordered eg-1 mt-3">
              <thead>
                <tr style={{ fontSize: "12px", fontWeight: "700" }}>
                   <th width="8%">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="coi"
                      checked={otherAllCheckStatus}
                      hidden={
                        !eligible ||
                        !OTHER_DOC_STATUS?.length ||
                        srnStatues?.status == "Closed" ||
                        srnStatues?.status == "Completed"
                          ? true
                          : false
                      }
                      onChange={() => {
                        markOtherAll(otherAllCheckStatus);
                      }}
                      id="defaultCheck1"
                      style={{ marginLeft: "10px" }}
                    />
                  </th>
                  <th style={{ textAlign: "center", width: "22%" }}>
                    Document Name
                  </th>
                  <th style={{ textAlign: "center" }}>Document</th>
                  <th style={{ textAlign: "center", width: "20%" }}>
                    Uploaded on
                  </th>
                  <th style={{ textAlign: "center", width: "15%" }}>Status</th>
                  {((eligible && allOtherDocuments?.some(item => !item?.is_submit)) ||
                    (auth?.roleId === ROLES.allianceManager && allOtherDocuments?.some(item => item?.status === "3"))) &&
                    <th style={{ textAlign: "center", width: "15%" }}>Action</th>}
                </tr>
              </thead>
              <tbody>
                {allOtherDocuments?.length > 0 &&
                  allOtherDocuments?.map((item, i) => {
                    return (
                      <tr key={i} style={{ fontSize: "12px" }}>
                        <td width="5%">
                          {item?.is_submit == 1 && <input
                            style={{ marginLeft: "14px" }}
                            class="form-check-input"
                            type="checkbox"
                            value="coi"
                            checked={
                              otherDocumentStatuss.includes(item.id.toString())
                                ? true
                                : false
                            }
                            onChange={() => {
                              let filteredItem1 = otherDocumentStatuss.filter(
                                (document) => document === item.id.toString()
                              );
                              let filteredItem2 = otherDocumentStatuss.filter(
                                (document) => document !== item.id.toString()
                              );
                              if (!filteredItem1.length > 0) {
                                setOtherDocumentStatuss([
                                  ...otherDocumentStatuss,
                                  item.id.toString(),
                                ]);
                              } else {
                                setOtherDocumentStatuss(filteredItem2);
                              }
                            }}
                            //  onChange={() =>{

                            //    setDocumentStatus({
                            //      ...documentStatus,
                            //      ["certificateOfIncorporate"]: !documentStatus.certificateOfIncorporate,
                            //     })
                            //   }
                            //  }
                            id="defaultCheck1"
                            hidden={
                              !eligible ||
                              item?.status != 2 ||
                              srnStatues?.status === "Closed" ||
                              srnStatues?.status === "Completed"
                                ? true
                                : false
                            }
                          />}
                          
                        </td>
                        <td>
                          <strong>{item?.document_name}</strong>
                        </td>
                        <td>
                        {(item?.is_submit === 1 || item?.status === "0") && 
                          <OverlayTrigger
                            overlay={
                              <Tooltip id="tooltip-disabled">Download</Tooltip>
                            }
                          >
                            <i
                              className="fa-solid fa-file-arrow-down"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                downloadSingleFile(
                                  item.name,
                                  item.id,
                                  item.extension,
                                  1
                                )
                              }
                              onKeyDown={() =>
                                downloadSingleFile(
                                  item.name,
                                  item.id,
                                  item.extension,
                                  1
                                )
                              }
                            ></i>
                          </OverlayTrigger>
                        }
                          &nbsp; {item?.is_submit === 1 || item?.status === "0" ? item?.name+"."+item?.extension : ""}

                        </td>
                        <td>
                          {(item?.is_submit === 1 || item?.status === "0") && moment(item?.created_at).format("DD-MM-YY hh:mm A")}
                        </td>
                        <td>
                          {(() => {
                            const statusMap = {
                              "0": { color: "red", text: "Rejected" },
                              "1": { color: "green", text: "Accepted" },
                              "2": { color: "orange", text: "Pending" },
                              "3": { color: "orange", text: "Approve for Admin" },
                              "4": { color: "orange", text: "Awaiting user upload" },
                            };

                            const status = statusMap[item?.is_submit || item?.status == 0 || item?.status == 3 ? item?.status : "4"];
                            if (!status) return null;

                            return (
                              <span>
                                <i
                                  className="fa fa-circle fa-fw"
                                  aria-hidden="true"
                                  style={{ color: status.color }}
                                ></i>{" "}
                                {status.text}
                              </span>
                            );
                          })()}
                        </td>
                        {((eligible && allOtherDocuments?.some(doc => !doc?.is_submit)) ||
                          (auth?.roleId === ROLES.allianceManager &&
                            allOtherDocuments?.some(doc => doc.status === "3"))) && (
                          <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                              {auth?.roleId === ROLES.allianceManager &&
                                item?.status === "3" && (
                                  <i
                                    className="fa fa-edit fa-fw fa-lg"
                                    style={{ cursor: "pointer", color: "green" }}
                                    onClick={() => {
                                      setEditModal(true);
                                      setEditData(item?.document_name);
                                      setEditId(item?.id);
                                    }}
                                  ></i>
                                )}

                              {eligible && !item?.is_submit && (
                                <i
                                  className="fa fa-trash fa-fw fa-lg"
                                  style={{ cursor: "pointer", color: "red" }}
                                  onClick={() => setDeleteConfirm({ show: true, id: item?.id, type: "other" })}
                                ></i>
                              )}
                            </div>
                          </td>
                        )}
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>}
      </div>
      
      {details?.is_final_submit === 1 && detailsList?.filter((doc) => doc?.service_mapped_license_fields_data?.[0]?.text_field || doc?.service_mapped_license_fields_data?.[0]?.min )?.length ? (
        <div className="card-body card-shadow mb-3 mt-5  card-sm">
              <h3 style={{ marginBottom: "0 !important" }} className="heading_light">
                <i
                  className="fa fa-copy fa-fw"
                  aria-hidden="true"
                  style={{ color: "#64308e" }}
                  title="License Details List"
                ></i>
                License Details List
              </h3>
              <table className="table table-bordered eg-1 mt-3">
                <thead>
                  <tr style={{ fontSize: "12px", fontWeight: "700" }}>
                    <th style={{ textAlign: "center" }}>Details Name</th>
                    <th style={{ textAlign: "center", width: "20%" }}>
                      Details type
                    </th>
                    <th style={{ textAlign: "center", width: "20%" }}>
                      Details Unit
                    </th>
                    <th style={{ textAlign: "center" }}>Selected/Entered value</th>
                  </tr>
                </thead>
                <tbody>
                  {detailsList?.length ? (
                    detailsList?.filter((doc) => doc?.service_mapped_license_fields_data?.[0]?.text_field || doc?.service_mapped_license_fields_data?.[0]?.min )?.map((detail, index) => {
                      return (
                        <tr>
                          <td>
                            {
                              detail?.service_mapped_license_fields_data[0]
                                ?.field_data?.name
                            }
                          </td>
                          <td>
                            {detail?.service_mapped_license_fields_data[0]?.field_data
                              ?.field_type == "0"
                              ? "Range"
                              : (detail?.service_mapped_license_fields_data[0]?.field_data
                                ?.field_type == "2") ? "Flat" : "Textfield"}
                          </td>
                          <td>
                            {
                              detail?.service_mapped_license_fields_data[0]
                                ?.field_data?.unit
                            }
                          </td>
                          <td>
                            {detail?.service_mapped_license_fields_data[0]?.field_data
                              ?.field_type == "0"
                              ? `${detail?.service_mapped_license_fields_data[0]?.min} - ${detail?.service_mapped_license_fields_data[0]?.max}  = INR ${detail?.service_mapped_license_fields_data[0]?.price} `
                              : detail?.text_field}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={4} className="text-center">
                        No details found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
      ):("")}

      {/* Delete confirmation modal */}
      <CustomModal
        show={deleteConfirm.show}
        headerTitle="Confirm Delete"
        onClose={() => setDeleteConfirm({ show: false, id: null, type: null })}
        onSubmit={() => {
          if (deleteConfirm.type === "srn") removeSrnDocument(deleteConfirm.id);
          else if (deleteConfirm.type === "other") UpdateOtherDocument(deleteConfirm.id);
          setDeleteConfirm({ show: false, id: null, type: null });
        }}
        onCloseText="Cancel"
        onSubmitText="Delete"
      >
        <p className="mb-0">Are you sure you want to delete this document?</p>
      </CustomModal>

    </>
  );
};

export default DocumentList;
